import {BaseEntity} from './BaseEntity';

export class BaseEntityUtils {

  static setDefaultProperties(target: any) {
    target.id = 0;
    target.createdBy = '';
    target.creationDate = new Date();
    target.modifiedBy = '';
    target.modifiedDate = new Date();
    target.version = 1;
    target.deleted = false;
  }
}
